import { useEffect, useState } from 'react'

/** Tailwind `md` breakpoint — single source of truth for JS-side checks. */
export const MD_BREAKPOINT = 768

/** Reactive `md` media query (true ≥ 768px). */
export function useIsDesktop(): boolean {
  return useMinWidth(MD_BREAKPOINT)
}

/** Reactive `(min-width: <px>)` media query. */
export function useMinWidth(px: number): boolean {
  const query = `(min-width: ${px}px)`
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)
  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])
  return matches
}
